import type { FC } from 'react';
import React, { useState } from 'react';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Aligner } from '@alfa-bank/site-aligner';
import type { FormApi } from 'final-form';
import type { TFormValues } from '@alfa-bank/site-form/src/models';
import cn from 'classnames';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { useDispatch } from 'react-redux';
import { passportCheckRequest } from '@alfa-bank/site-dc-form-api/store';

import { passportStepAnalytics as analytics } from '../../analytics';

import type { IPassportStepFormValues, TPassportStep } from './models';

export const PassportStep: FC<TPassportStep> = ({
    Button,
    Form,
    Layout,
    PassportInput,
    Text,
    button,
    isMobile,
    mainTitle,
    styles,
    textView,
    title,
}) => {
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = (formRef: HTMLFormElement, form: FormApi<TFormValues>) => {
        setSubmitting(true);

        const { passport } = form.getState().values as unknown as IPassportStepFormValues;
        const passportFullNumber = passport.replace(' ', '');

        dispatch(passportCheckRequest(passportFullNumber));

        setSubmitting(false);

        sendEvent(analytics.submit);
    };

    return (
        <Layout
            className={cn(styles.passport, styles.external)}
            contentWidth={isMobile ? 600 : 558}
            dataTestId="dc-form-passport-step"
            hasPadding={false}
        >
            <Form noValidate onSubmit={onSubmit} showFormOuterWrapper={false}>
                <Grid alignment="center" collapse columnsMargin={0} vertical>
                    <Aligner>
                        <Text styler={{ margin: 0, padding: 0 }} view={textView.mainTitle}>
                            {mainTitle}
                        </Text>
                    </Aligner>
                    <Aligner>
                        <Text styler={{ margin: 0, paddingTop: 24 }} view={textView.title}>
                            {title}
                        </Text>
                    </Aligner>
                    <Layout
                        contentWidth={isMobile ? undefined : 270}
                        hasPadding={false}
                        styler={{
                            margin: 0,
                            paddingTop: 24,
                        }}
                    >
                        <PassportInput
                            className={cn(styles.inputWrapper, styles.external)}
                            onError={() => sendEvent(analytics.passport.incorrect)}
                            onFocus={() => sendEvent(analytics.passport.focus)}
                            onSuccess={() => sendEvent(analytics.passport.correct)}
                        />
                        <Button
                            block
                            loading={submitting}
                            size="s"
                            styler={{ margin: 0, paddingTop: 24 }}
                            type="submit"
                            view="primary"
                        >
                            {button}
                        </Button>
                    </Layout>
                </Grid>
            </Form>
        </Layout>
    );
};
